const axios = require('axios').default;

export const getAddressDataAsync = async function () {
    // Read content of /assets/data_dia_phuong.json and return it
    const resp = await axios.get('/assets/data_dia_phuong.json');
    return resp.data;
}